import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RollLabelProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/roll-label';

  public getThermalLabelByRollNumber(number: string): Observable<Blob> {
    return this.httpClient.get(this.baseUrl + '/thermal/' + encodeURIComponent(number), {
      responseType: 'blob',
    });
  }
}
